module.exports = __webpack_public_path__ + "img/bank7.3aa17669.png";